import CandidateSettingsContainer from './candidate_settings_container';

const CandidateSettings = CandidateSettingsContainer;
export default CandidateSettings;
